import BaseModel from "./base/baseModel";

export default class ProdutoRefrigeradoFormaFarmaceuticaModel extends BaseModel {
    id?: number;
    produtoId: number;
    formaFarmaceuticaId: number;
    formaFarmaceuticaDescricao: string;
}
